import {isPlatformBrowser} from '@angular/common';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {OptionsDialogComponent} from './dialogs/options-dialog/options-dialog.component';
import {PartageDialogComponent} from './dialogs/partage-dialog/partage-dialog.component';
import {FreeAmountDialogComponent} from './dialogs/free-amount-dialog/free-amount-dialog.component';
import {ShareItemsDialogComponent} from './dialogs/share-items-dialog/share-items-dialog.component';
import {TipsDialogComponent} from './dialogs/tips-dialog/tips-dialog.component';
import {RecapPaymentDialogComponent} from './dialogs/recap-payment-dialog/recap-payment-dialog.component';
import {InfoDialogComponent} from './dialogs/info-dialog/info-dialog.component';
import {NoteNotFoundDialogComponent} from './dialogs/note-not-found-dialog/note-not-found-dialog.component';
import {PaymentMethodDialogComponent} from './dialogs/payment-method-dialog/payment-method-dialog.component';
import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {CssService} from 'src/app/services/css-service';
import {ActivatedRoute, Router} from '@angular/router';
import {ActivityService} from 'src/app/services/user/activity.service';
import {Subject, Subscription, timer} from 'rxjs';
import {debounce} from 'rxjs/operators';
import {AuthService} from 'src/app/services/auth/auth.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {CommMessage} from '../../stripe-web/stripe-web.component';
import {SelectItemsDialogComponent} from './dialogs/select-items-dialog/select-items-dialog.component';
import {OverPaymentDialogComponent} from './dialogs/over-payment-dialog/over-payment-dialog.component';
import {FullyPaidDialogComponent} from './dialogs/fully-paid-dialog/fully-paid-dialog.component';
import {PaymentHistoryDialogComponent} from './dialogs/payment-history-dialog/payment-history-dialog.component';
import {DecodedToken} from 'src/app/services/qrcode/qrcode.service';
import {ContextAppService} from "../../../services/context-app-service";
import {BaseclientService} from 'src/app/services/apiclient/baseclient.service';
import {cloneDeep} from 'lodash';
import {StripeDialogWrapperComponent} from './component/stripe-dialog-wrapper/stripe-dialog-wrapper.component';

interface ApiResponse {
  code: number;
  list: WaitingNote[];
}

export interface AppUser {
  uid: string;
  email: string;
  displayName: string | null;
  phoneNumber: string | null;
  photoURL: string | null;
  providerId: string;
}

export interface Item {
  id: number;
  quantity: number;
  unit_ttc: number;
  partialQuantity: number;
  remainingQuantity: number;
  alreadyPaid: boolean;
  free: number;
  selected: boolean;
  uuid?: string;
  children?: Item[];
  name?: string;
  NAME?: string;
  id_user?: number;
  total_ttc?: number;
  paidQuantity?: number;
  shared_index?: number;
  shared_total?: number;
  amount_paid?: number;
  quantity_paid?: number;
}

export interface Payment {
  archive: number;
  captured?: number;
  total?: number;
  details?: {
    id_product: number;
    quantity_paid: number;
    uuid?: number;
    SHARED_INDEX?: number;
  }[];
  id_payment_mean: number;
  type_payment: number;
  TIPS: number | null;
}

export interface PaymentDetail {
  id_product: number;
  quantity_paid: number;
  amount_paid: number;
  uuid: string;
  shared_index?: number;
  shared_total?: number;
  name?: string;
}

export interface PointOfSale {
  id: number;
  name: string;
  logo: string[] | null;
  banner: string[] | null;
  denomination: string;
  stripe_account?: string | null;
  phone?: string | null;
  address?: string | null;
  postal?: string | null;
  city?: string | null;
  enable_order?: number | null;
  id_webshop?: number;
  country: Country;
  key?: number;
  enable_order_intent: number;
  enable_payment_note_intent: number;
  coordinates: string;
}

export interface Country {
  id: number;
  code: string;
  name: string;
  activity_title?: string;
  currency: number;
  default_price_type?: number;
  flag?: string;
  identification_title?: string;
  lang?: string;
  phone_code?: string;
  rcs_title?: string;
  sms_country_price?: number;
  tax_decimals: number;
  tax_processing_fees?: number;
  tax_title?: string;
  timezone?: string;
  tva_link?: string;
  tva_number?: string;
  tva_stripe?: number;
  visible?: number;
}

export interface CurrencyFormat {
  decimalsString: string;
  currencySymbol: string;
}

export interface SharedPart {
  amount_paid: number;
  id_product: number;
  shared_index: number;
  shared_total: number;
  uuid: string;
  name?: string;
}

type ShareItemsDialogResult =
  | { action: 'cancel-division'; item: Item }
  | SharedPart[];

export interface WaitingNote {
  id: number;
  r_note?: string;
  n_people?: number;
  n_table?: number;
  archive?: number;
  details: Item[];
  shared_parts: SharedPart[];
  payments: Payment[];
  country: Country;
  currency: CurrencyFormat;
}

interface StripeDialogResult {
  paymentID: number;
  paymentIntent: {
    id: string;
    status: 'succeeded' | 'requires_payment_method' | 'processing' | 'requires_action' | 'canceled' | string;
    amount: number;
    [key: string]: unknown; // pour d'autres champs potentiels
  };
}

@Component({
  selector: 'app-root',
  templateUrl: './waitingnotes.component.html',
})
export class WaitingNotesComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private activityService: ActivityService,
    private af: AngularFireAuth,
    private authService: AuthService,
    public cssService: CssService,
    private dialog: MatDialog,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private baseClient: BaseclientService,
    public contextAppService: ContextAppService,
    public translate: TranslateService,
    // private qrcodeservice: QRCodeService,
    // private pngGenerator: PngGeneratorService,
  ) {
  }

  paymentID: any;
  ////// Variables liées au composant et au contexte global //////
  pointOfSale: any | null = null; // Point de vente actif (renseigné par le code dans l'URL).
  posCountry: Country | null = null; // Donnees du pays du PoS.
  currencySymbol = '';
  currencyDecimals = '';
  tableNumber = 0; // Paramètre de la route, pour identifier la table (le numéro de table en cours).
  today: Date = new Date(); // Date du jour (pour l'affichage éventuel).
  user: AppUser | null = null; // Stocke les informations de l'utilisateur connecté (Firebase).
  currentIdWebshop: string | number | null = null; // Identifiant du Webshop courant (utile pour l'API).
  waitingNotes: ApiResponse | null = null; // Données principales de la note (récupérées via l'API).
  isUserActive = true; // Gestion de l'activité de l'utilisateur (activité = souris, clavier…).
  urlBase = environment.apiUrl; // Stocke l'url.
  private autoRefreshInterval: ReturnType<typeof setInterval> | undefined; // Intervalle pour l'auto-refresh (5s par défaut).
  private activitySub?: Subscription; // Subscription pour la détection d'inactivité (RxJS).
  public isAutoRefreshEnabled = true;// Contrôle l'activation de l'auto-refresh (si inactif, désactivé).

  ////// Variables liées aux articles et paiements //////
  structuredItems: Item[] = []; // Liste structurée des items (avec filtrage, formatage des items partagés…).
  totalBrut = 0; // Montant total brut des articles (calculé localement).
  paidAmount = 0; // Montant total déjà payé (calculé à partir des paiements).
  selectedTotals = {rawTotal: 0, maxTotal: 0, finalTotal: 0}; // Résumé dynamique des totaux des articles sélectionnés (total brut, max, final).
  paymentDetails: PaymentDetail[] = []; // Détails des paiements à envoyer au backend (générés au moment du paiement).
  selectedUUIDS: { [uuid: string]: { checked: boolean; item: Item } } = {}; // Stocke l’état de sélection des UUIDs (ex: { uuid: { checked: true, item: Item } }).

  ////// Variables pour l’UI (état d’affichage) //////
  isLoading = true; // Indique si l'application est en cours de chargement (spinner, etc.).
  showPaymentOptions = false; // Affiche ou masque les options de paiement (dialog OptionsDialog).
  allItemsSelected = false; // État de la sélection globale (tous les items sont sélectionnés ou non).
  noteNotFoundDialogRef: MatDialogRef<NoteNotFoundDialogComponent> | null = null; // Sert a fermer la dialog not found dans le cas ou la note se cree avec un refresh actif.

  decodedPayload: DecodedToken = {
    route: 'note',
    id: 0,
    code: '',
    table: 0,
  };

  ////// Variables calculées / facilitatrices (getters) //////
  get firstNote(): WaitingNote | undefined {
    return this.waitingNotes?.list?.[0];
  } // Raccourci pour récupérer la première note (souvent la seule).
  private buildSharedPartsAsItems(sharedParts: SharedPart[]): Item[] {
    return sharedParts.map(p => ({
      id: p.id_product,
      name: `${p.name} - ${p.shared_index}/${p.shared_total}`,
      quantity: 1,
      partialQuantity: 1,
      unit_ttc: Number(p.amount_paid ?? 0),
      total_ttc: Number(p.amount_paid ?? 0),
      uuid: p.uuid,
      shared_index: p.shared_index,
      shared_total: p.shared_total,
      alreadyPaid: false,
      free: 0,
      selected: false,
      remainingQuantity: 1,
      children: [],
    }));
  }

  ngOnInit(): void {

    // Numéro de table
    this.decodedPayload.table = this.route.snapshot.params['locValue'];

    this.getClient();
    try {
      this.getPointOfSale();
      if (isPlatformBrowser(this.platformId)) {
        this.startAutoRefresh();
        // Détection activité → redevient actif
        this.activityService.activity$.subscribe(() => {
          this.isUserActive = true;
        });
        // Détection inactivité → devient inactif
        this.activitySub = this.activityService.activity$
          .pipe(debounce(() => timer(10000))) // 10s d’inactivité
          .subscribe(() => {
            this.isUserActive = false;
          });
      }
    } catch (e) {
      console.error('Erreur de chargement :', e);
      this.router.navigate(['/404']);
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.stopAutoRefresh();
      this.activitySub?.unsubscribe();
    }
  }

  onError(place: string, error: unknown): void {
    if (error instanceof Error) {
      console.error(place, ":", error.message);
    } else {
      console.error(place, ":", error);
    }
    this.stopAutoRefresh();
  }

  getPointOfSale() {
    this.tableNumber = this.decodedPayload['table'];
    this.pointOfSale = this.contextAppService.currentPointOfSale;
    // console.log("this.pointOfSale :", this.pointOfSale)
    if (this.pointOfSale) {
      this.getWaitingNotes({id_pos: this.pointOfSale.id, n_table: this.decodedPayload['table']})
        .then((note: ApiResponse) => {
          // console.log("waitingnotes.component - getPointOfSale - note : ", note)
          const notes = note?.list ?? [];
          const firstNote = notes?.[0];
          // Gestion note vide
          if (!firstNote || !firstNote.details) {
            this.showNoteNotFoundDialog(`${this.pointOfSale?.name}`, this.decodedPayload['table']);
            return;
          }
          this.isAutoRefreshEnabled = true;
          this.waitingNotes = note;
          // console.log('this.waitingNotesthis.waitingNotesthis.waitingNotes:', this.waitingNotes);
          // Récupération des articles.
          const details = this.firstNote?.details ?? [];
          const sharedParts = this.firstNote?.shared_parts ?? [];
          // 🛠️ Filtrer les originaux déjà divisés
          const sharedIds = new Set(sharedParts.map(p => p.id_product));
          const filteredDetails = details.filter(d =>
            !(sharedIds.has(d.id) && d.shared_index === undefined)
          );
          // Recréer les items partagés
          const sharedPartsAsItems = this.buildSharedPartsAsItems(sharedParts);
          // 🧱 Fusion propre
          this.structuredItems = [...filteredDetails, ...sharedPartsAsItems];
          this.totalBrut = this.calculateTotal(this.structuredItems);
          this.paidAmount = this.calculatePaidAmount();
          this.markPaidItems();
          this.checkPayment(this.paidAmount, this.totalBrut);
          if (this.pointOfSale) {
            this.getPointOfSaleCountry(this.pointOfSale.country.code).then((country) => {
              this.posCountry = country ? country : null;
              if (this.posCountry !== null) {
                this.getCurrencyFormat(this.posCountry.tax_decimals, this.posCountry?.currency)
              }
            });
          }
        });
    }
  }

  getClient() {
    this.authService.getUser.subscribe((user: AppUser) => {
      if (user) {
        // Compte client final
        this.user = user;
      }
    });
  } // Methode pour récupérer le client connecté (facultatif n'est la que pour des eventuels cartes de fidelites, etc...)

  async getIdToken(): Promise<string> {
    const user = await this.af.currentUser;
    return user?.getIdToken(false) ?? "invalid_token";
  } // Auth token Firebase

  postBaseApi(endpoint: string, param: Record<string, unknown> = {}): Promise<unknown> {
    param['id_webshop'] = param['id_webshop'] || this.getStor<PointOfSale>("point_of_sale")?.id_webshop;
    if (typeof param['id_webshop'] === 'string') {
      this.currentIdWebshop = param['id_webshop'];
    }

    return this.http.post(this.urlBase + endpoint, param, {
      headers: {"Content-Type": "application/json"}
    }).toPromise();
  }

  async getBaseApi<T>(endpoint: string, params: Record<string, unknown> = {}): Promise<T> {
    const id_webshop = typeof params['id_webshop'] === 'string'
      ? params['id_webshop']
      : this.getStor<PointOfSale>("point_of_sale")?.id_webshop ?? "";

    this.currentIdWebshop = id_webshop;
    const queryParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        queryParams.set(key, String(value));
      }
    }

    if (!params['id_webshop'] && id_webshop) {
      queryParams.set('id_webshop', String(id_webshop));
    }

    const url = `${this.urlBase}${endpoint}?${queryParams.toString()}`;

    // ✅ Ici on force la promesse à toujours retourner quelque chose
    try {
      const res = await this.http.get<T>(url).toPromise();
      return res as T;
    } catch (err) {
      this.onError('API error:', err);
      throw err; // ou return {} as T si tu veux forcer vide
    }
  }

  startAutoRefresh(): void {
    this.checkForWaitingNotesUpdate();
    this.stopAutoRefresh();

    this.autoRefreshInterval = setInterval(() => {
      if (this.isAutoRefreshEnabled && this.isUserActive) {
        this.checkForWaitingNotesUpdate();
      }
    }, 5000);
  }

  stopAutoRefresh(): void {
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
      this.autoRefreshInterval = undefined;
    }
  }

  setStor(key: string, val: unknown): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem(key, JSON.stringify(val));
    }
  }

  getStor<T>(key: string): T | null {
    if (isPlatformBrowser(this.platformId)) {
      const item = sessionStorage.getItem(key);
      return item && item !== "undefined" ? JSON.parse(item) as T : null;
    }
    return null;
  }

  // async getPointOfsaleById(posId: string, filter = true): Promise<PointOfSale> {
  // async getPointOfsaleById(posId: string): Promise<PointOfSale> {
  //   // console.log("posId :", posId)
  //   const response = await this.getBaseApi<PointOfSale>("custom/point_of_sale", {id_webshop: posId});
  //   if (!response) {
  //     this.router.navigate(["/404", this.translate.instant('error404.noPof')], {skipLocationChange: true});
  //   }
  //   return response;
  // }

  async getPointOfSaleCountry(code: string): Promise<Country | null> {
    const response = await this.getBaseApi<{ countries: Country[] }>("getCountries");
    const countries = response.countries || [];
    const found = countries.find(p => p.code === code);
    if (!found) {
      this.router.navigate(["/404", this.translate.instant('error404.noPof')], {skipLocationChange: true});
      return null;
    }
    return found;
  }

  getCurrencyFormat(decimals: number, countryCode: number): void {

    if (!this.firstNote) return;

    const currencyMap: Record<number, { symbol: string; decimals: number }> = {
      978: {symbol: '€', decimals: 2},     // Euro
      840: {symbol: '$', decimals: 2},     // Dollar US
      826: {symbol: '$', decimals: 2},     // Pound
      756: {symbol: 'CHF', decimals: 2},   // Franc Suisse
      356: {symbol: '₹', decimals: 0},     // Roupie indienne
      360: {symbol: 'Rp', decimals: 0},    // Roupie indonésienne
      36: {symbol: '$', decimals: 2},     // Dollar australien
      124: {symbol: '$', decimals: 2},     // Dollar canadien
      952: {symbol: 'CFA', decimals: 0},   // Franc CFA
      504: {symbol: 'dh', decimals: 2},    // Dirham Marocain
      953: {symbol: 'XPF', decimals: 0},   // Franc Pacifique
      969: {symbol: 'Ar', decimals: 0},    // Ariary malgache
      12: {symbol: 'د.ج', decimals: 0},   // Dinar algérien
      818: {symbol: '£E', decimals: 2},    // Livre égyptienne
      788: {symbol: 'DT', decimals: 3},    // Dinar tunisien
      324: {symbol: 'GNF', decimals: 0},   // Franc guinéen
      976: {symbol: 'FC', decimals: 0},    // Franc Congolais
      174: {symbol: 'FC', decimals: 0},    // Franc comorien
      480: {symbol: 'Rs', decimals: 2},    // Roupie mauricienne
      484: {symbol: '$', decimals: 0},     // Peso colombien
      32: {symbol: '$', decimals: 2},     // Peso argentin
      951: {symbol: 'EC$', decimals: 2},   // Dollar des Caraïbes orientales
      690: {symbol: 'SR', decimals: 0},    // Roupie seychelloise
      710: {symbol: 'R', decimals: 2},     // Rand (Afrique du Sud)
      208: {symbol: 'Kr', decimals: 2},    // Kroner danoise
    };

    const currency = currencyMap[countryCode];

    if (currency) {
      this.firstNote.currency = {
        decimalsString: `1.${currency.decimals}-${currency.decimals}`,
        currencySymbol: currency.symbol,
      };
    } else {
      // Par défaut, Euro
      this.firstNote.currency = {
        decimalsString: `1.${decimals}-${decimals}`,
        currencySymbol: '€',
      };
    }

    this.currencySymbol = this.firstNote.currency.currencySymbol;
    this.currencyDecimals = this.firstNote.currency.decimalsString;
  }

  checkForWaitingNotesUpdate() {
    const id_pos = this.pointOfSale?.id;
    const n_table = this.decodedPayload['table'];
    if (!id_pos || !n_table) return;

    // 🔁 Sauvegarde de l’état sélectionné AVANT tout remplacement
    const previousSelections = new Map<string, { selected: boolean; partialQuantity: number }>();

    const saveState = (items: Item[]) => {
      for (const item of items) {
        const key = this.getStableKey(item);
        previousSelections.set(key, {
          selected: item.selected || false,
          partialQuantity: item.partialQuantity || 0,
        });
        if (item.children?.length) saveState(item.children);
      }
    };

    // 🔄 Restaure l’état sélectionné APRÈS la mise à jour
    const restoreState = (items: Item[]) => {
      for (const item of items) {
        const key = this.getStableKey(item);
        const saved = previousSelections.get(key);
        if (saved) {
          item.selected = saved.selected;
          item.partialQuantity = saved.partialQuantity;
        }
        if (item.children?.length) restoreState(item.children);
      }
      this.updateSelectedTotal();
    };
    saveState(this.structuredItems);

    // 🔄 Récupération des nouvelles données
    this.getWaitingNotes({id_pos, n_table}).then(note => {
      // Vérification que note n'est pas null.
      this.waitingNotes = note;
      const firstNote = note?.list?.[0];

      if (!firstNote || !firstNote.details) {
        if (!this.noteNotFoundDialogRef) {
          this.showNoteNotFoundDialog(`${this.pointOfSale?.name}`, this.decodedPayload['table']);
        }
        return;
      }
      // si l'etat de note change on ferme la dialog NoteNotFound
      if (this.noteNotFoundDialogRef) {
        this.noteNotFoundDialogRef.close();
        this.noteNotFoundDialogRef = null;
      }
      // 1. Reconstituer les détails
      const details = this.firstNote?.details ?? [];
      const sharedParts = this.firstNote?.shared_parts ?? [];
      // 2. Ne conserver qu’un original si aucune part n’existe
      const sharedIds = new Set(sharedParts.map(p => p.id_product));
      const filteredDetails = details.filter(d =>
        !(sharedIds.has(d.id) && d.shared_index === undefined)
      );
      // 3. Recréer les items “partagés”
      const sharedPartsAsItems = this.buildSharedPartsAsItems(sharedParts);
      // 4. 🧱 Remplacement principal
      this.structuredItems = [...filteredDetails, ...sharedPartsAsItems];
      // 5. Mettre à jour les statuts payés, totaux, etc.
      this.markPaidItems();
      this.totalBrut = this.calculateTotal(this.structuredItems);
      this.paidAmount = this.calculatePaidAmount();
      this.checkPayment(this.paidAmount, this.totalBrut);
      this.updateSelectedTotal();
      // 🔄 Restaure l’état sélectionné (quantité et sélection) après l’actualisation
      restoreState(this.structuredItems);

    });
  }

  async getWaitingNotes(params: { id_pos: number, n_table: number }): Promise<ApiResponse> {
    const token = await this.getIdToken();
    const httpParams = new HttpParams()
      .set('id_pos', params.id_pos)
      .set('n_table', params.n_table);
    const note = await this.http.get<ApiResponse>(this.urlBase + 'waiting-notes', {
      headers: {Authorization: token},
      params: httpParams
    }).toPromise();

    if (!note) {
      throw new Error('Aucune note reçue du serveur.');
    }
    return note;
  }

  async getPaymentMean(id: number): Promise<ApiResponse> {
    const token = await this.getIdToken();

    const paymentMeanResult = await this.http.get<ApiResponse>(
      `${this.urlBase}payment-mean/${id}`,
      {
        headers: {Authorization: token}
      }
    ).toPromise();

    if (!paymentMeanResult) {
      throw new Error('Aucune paymentMeanResult reçue du serveur.');
    }

    return paymentMeanResult;
  }


  roundAmount(amount: number, decimals = 2): number {
    return Math.round(amount * Math.pow(10, decimals)) / Math.pow(10, decimals);
  }

  startPaymentFlow(option: 'full' | 'options'): void {
    if (option === 'full') {
      this.openTipsDialog(1, (this.totalBrut - this.paidAmount));
    } else if (option === 'options') {
      const dialogRef = this.dialog.open(OptionsDialogComponent, {
        // position: { bottom: '0' },
        panelClass: 'dialog-bottom-full',
      });

      dialogRef.afterClosed().subscribe((option: string | null) => {
        if (!option) return;
        switch (option) {
          case 'select-items':
            this.openSelectItemsDialog();
            break;
          case 'partage':
            this.openPartageDialog();
            break;
          case 'free-amount':
            this.openFreeAmountDialog();
            break;
          case 'share-items':
            this.openShareItemsDialog();
            break;
        }
      });
    }
  }

  openSelectItemsDialog(): void {
    this.stopAutoRefresh();
    const dialogRef = this.dialog.open(SelectItemsDialogComponent, {
      data: {
        items: this.structuredItems,
        currencyFormat: {decimalsString: this.currencyDecimals, currencySymbol: this.currencySymbol}
      },
      // position: { bottom: '0' },
      panelClass: 'dialog-bottom-full',
    });

    dialogRef.afterClosed().subscribe((selectedItems: Item[] | null) => {
      if (selectedItems) {
        // 🟡 Mets à jour la sélection en local
        this.structuredItems.forEach(item => {
          item.selected = selectedItems.some(si => this.getStableKey(si) === this.getStableKey(item));
          // 🔴 À AJOUTER pour la quantité
          if (item.selected) {
            const selectedItem = selectedItems.find(si => this.getStableKey(si) === this.getStableKey(item));
            item.partialQuantity = selectedItem?.partialQuantity ?? 1;
          }
        });
        this.updateSelectedTotal();
        this.openTipsDialog(3, this.getSelectedTotals().rawTotal);
      }
      this.startAutoRefresh();
    });
  }

  openPartageDialog(): void {
    this.stopAutoRefresh();
    const dialogRef = this.dialog.open(PartageDialogComponent, {
      // position: { bottom: '0' },
      panelClass: 'dialog-bottom-full',
      data: {
        totalAmount: (this.totalBrut - this.paidAmount),
        currencyFormat: {decimalsString: this.currencyDecimals, currencySymbol: this.currencySymbol}
      }
    });

    dialogRef.afterClosed().subscribe((returnAmount: number | null) => {
      if (returnAmount) {
        this.openTipsDialog(2, returnAmount);
      }
      this.startAutoRefresh();
    });
  }

  openFreeAmountDialog(): void {
    this.stopAutoRefresh();
    const dialogRef = this.dialog.open(FreeAmountDialogComponent, {
      // position: { bottom: '0' },
      panelClass: 'dialog-bottom-full',
      data: {
        totalAmount: (this.totalBrut - this.paidAmount),
        currencyFormat: {decimalsString: this.currencyDecimals, currencySymbol: this.currencySymbol}
      }
    });

    dialogRef.afterClosed().subscribe((returnAmount: number | null) => {
      if (returnAmount !== null) {
        this.openTipsDialog(2, returnAmount);
      }
      this.startAutoRefresh();
    });
  }

  openTipsDialog(paymentType: number, returnAmount: number): void {
    // console.log("openTipsDialog is called")

    this.stopAutoRefresh();
    const dialogRef = this.dialog.open(TipsDialogComponent, {
      // position: { bottom: '0' },
      panelClass: 'dialog-bottom-full',
      data: {returnAmount: returnAmount, decimalsString: this.currencyDecimals, currencySymbol: this.currencySymbol}
    });

    dialogRef.afterClosed().subscribe((tipAmount: number) => {
      this.openRecapPaymentDialog(paymentType, tipAmount, returnAmount);
      this.startAutoRefresh();
    });
  }

  openRecapPaymentDialog(paymentType: number, tipAmount: number, returnAmount: number): void {
    // console.log("openRecapPaymentDialog is called")

    this.stopAutoRefresh();
    const dialogRef = this.dialog.open(RecapPaymentDialogComponent, {
      // position: { bottom: '0' },
      panelClass: 'dialog-bottom-full',
      data: {
        items: this.structuredItems,
        totalAmount: this.totalBrut,
        alreadyPaidAmount: this.paidAmount,
        tipAmount: tipAmount,
        returnAmount: returnAmount,
        currencyFormat: {decimalsString: this.currencyDecimals, currencySymbol: this.currencySymbol},
      }
    });

    dialogRef.afterClosed().subscribe((amount: number) => {
      if (amount > 0) {
        this.openPaymentMethodDialog(paymentType, amount, tipAmount);
      }
      this.startAutoRefresh();
    });
  }

  openPaymentMethodDialog(payment_type: number, paymentAmount: number, tipAmount: number): void {
    // console.log("openPaymentMethodDialog is called")

    this.stopAutoRefresh();
    const dialogRef = this.dialog.open(PaymentMethodDialogComponent, {
      // position: { bottom: '0' },
      panelClass: 'dialog-bottom-full',
      data: {payment_type, paymentAmount},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'stripe') {
        this.openStripeDialog(payment_type, paymentAmount, tipAmount);
      } else if (result === 'paypal' || result === 'googlepay') {
        console.error('❌ Cette méthode de paiement n’est pas encore implémentée');
        this.startAutoRefresh();
      }
    });
  }

  async openStripeDialog(payment_type: number, paymentAmount: number, tipAmount: number): Promise<void> {
    // console.log("openStripeDialog is called")

    this.stopAutoRefresh();

    const selectedItems = this.structuredItems
      .filter(item => item.selected && item.partialQuantity > 0)
      .map(item => ({
        id_product: item.id,
        quantity_paid: item.partialQuantity,
        amount_paid: (item.unit_ttc ?? 0) * (item.partialQuantity ?? 0),
        uuid: item.uuid || null
      }));

    const amount = this.roundAmount(paymentAmount + tipAmount);
    const comm$ = new Subject<CommMessage>();

    const myStripeConf = {
      comm$: comm$,
      amount: amount,
      popupStyleParams: "none",
      //TODO enlever à terme
      metadata: 4,
      //TODO enlever à terme
      id_user: this.firstNote?.details[0].id_user
    }
    // console.log(myStripeConf);

    // souscription côté parent pour recevoir paymentIntent et renvoyer confirmation
    const sub = comm$.subscribe(msg => {
      // console.log("subscribe", msg);

      // On a recu de la popup un evenement de création de paymentIntent
      if (msg.type === 'paymentIntent') {
        // console.log("msg : ", msg)
        const nextMsg: any = cloneDeep(msg)
        // On créé la ligne d'encaissement sur la note en attente
        this.createNotePaymentIntent(amount, tipAmount, selectedItems, msg.data.paymentIntent.id).then(msg => {

          // LA ligne a été insérée
          if (msg.payment_id > 0) {
            // console.log("msg.payment_id : ", msg.payment_id)
            this.paymentID = msg.payment_id;
            nextMsg.type = 'confirm';
          } else {
            nextMsg.type = 'error';
          }
          comm$.next(nextMsg);
        })
      }
    });


    //TODO pour démo uniquement
    if (true) {

      let paymentIntentID = crypto.randomUUID();

      this.createNotePaymentIntent(amount, tipAmount, selectedItems, paymentIntentID).then(msg => {

        // LA ligne a été insérée
        if (msg.payment_id > 0) {
          // console.log("msg.payment_id : ", msg.payment_id)
          this.paymentID = msg.payment_id;
          // console.log("afterClosed is called")

          this.afterStripeDialogClosed();

          sub.unsubscribe();
          comm$.complete();

          this.sendStripePaymentToBackend(this.paymentID, paymentIntentID, amount,
            tipAmount, payment_type, this.getSelectedItems()); // Attention, Stripe retourne le montant payé en centimes
          if (payment_type === 3 && this.paymentDetails?.length) {
            this.setStor("shared_details", this.paymentDetails);
          }

          this.startAutoRefresh();
        }
      })

    } else {
      const dialogRef = this.dialog.open(StripeDialogWrapperComponent, {
        panelClass: 'dialog-bottom-full',
        data: myStripeConf
      });

      dialogRef.afterClosed().subscribe((result: StripeDialogResult | undefined) => {
        // console.log("afterClosed is called")
        // console.log(result)

        this.afterStripeDialogClosed();

        sub.unsubscribe();
        comm$.complete();

        if (result && result.paymentIntent) {
          if (result.paymentIntent.status === 'succeeded') {
            this.sendStripePaymentToBackend(this.paymentID, result.paymentIntent.id, result.paymentIntent.amount / 100,
              tipAmount, payment_type, this.getSelectedItems()); // Attention, Stripe retourne le montant payé en centimes
            if (payment_type === 3 && this.paymentDetails?.length) {
              this.setStor("shared_details", this.paymentDetails);
            }
          }
        } else {
          console.warn('❌ Paiement annulé ou échoué');
        }
        this.startAutoRefresh();
      });
    }
  }

  afterStripeDialogClosed() {

  }

  // Création de la ligne dans la table waiting notes payment
  createNotePaymentIntent(amount: number, tips: number, selectedItems: any, paymentIntentId: string) {

    const payload = {
      id_webshop: this.contextAppService.webshopId,
      id_waiting_note: this.firstNote?.id,
      id_payment_mean: -42,
      total: amount - tips,
      tips: tips,
      type_payment: 0,
      id_payment_intent: paymentIntentId,
      archive: 0,
      details: selectedItems ?? []
    };

    return this.baseClient.postBase('waiting-note-payment', payload)
  }

  async sendStripePaymentToBackend(
    paymentID: number,
    paymentIntentId: string,
    paymentAmount: number,
    tipAmount: number,
    type_payment: number,
    selectedItems: Item[]
  ) {
    if (!paymentID || !paymentIntentId || paymentAmount <= 0) {
      this.showInfoDialog("Erreur", "Informations de paiement invalides.", true);
      this.onError("Erreur : Informations de paiement invalides.", {
        paymentID: paymentID,
        paymentIntentId: paymentIntentId,
        paymentAmount: paymentAmount
      });
      return;
    }

    const note = this.waitingNotes?.list;
    if (!note || !note[0].id || !note[0].details?.length) {
      this.showInfoDialog("Erreur", "Impossible d'enregistrer le paiement Stripe.", true)
      this.onError("Erreur : Impossible d'enregistrer le paiement Stripe.", note);
      return;
    }

    if (type_payment === 3 && (!this.paymentDetails || this.paymentDetails.length === 0)) {
      // console.warn("Aucun détail de partage détecté — on régénère depuis les articles sélectionnés !");
      this.paymentDetails = this.getSelectedItems().map(item => ({
        id_product: item.id,
        quantity_paid: item.partialQuantity,
        amount_paid: (item.unit_ttc ?? 0) * (item.partialQuantity ?? 0),
        uuid: this.getStableKey(item),
        shared_index: item.shared_index,
        shared_total: item.shared_total,
        name: item.name,
      }));
    }

    const details = type_payment === 3
      ? this.getSelectedItems().map(item => ({
        id_product: item.id,
        quantity_paid: item.partialQuantity,
        amount_paid: (item.unit_ttc ?? 0) * (item.partialQuantity ?? 0),
        uuid: this.getStableKey(item),
        shared_index: item.shared_index,
        shared_total: item.shared_total,
        name: item.name,
      }))
      : selectedItems.map(item => ({
        id_product: item.id,
        quantity_paid: item.partialQuantity,
        amount_paid: (item.unit_ttc ?? 0) * (item.partialQuantity ?? 0),
        uuid: this.getStableKey(item),
      }));

    const payload = {
      payment_id: paymentID,
      id_user: note[0].details[0]?.id_user,
      id_waiting_note: note[0].id,
      id_payment_mean: -42,
      id_payment_intent: paymentIntentId,
      total: paymentAmount - tipAmount, //le tipAmount a ete ajoute pour le payer il faut maintenant l'enlever pour le mettre a part en bdd
      tips: tipAmount,
      type_payment: type_payment,
      captured: 1,
      details: details,
    };

    try {
      await this.postBaseApi('update-waiting-note-payment', payload);
      this.showPaymentOptions = false;
      // const paymentString = `Vous venez de payer ${paymentAmount} ${this.currencySymbol} et ${tipAmount} ${this.currencySymbol}. Merci beaucoup.`
      // this.sendimageToDevice(paymentString, 'iF8aXSxd', '87141');
      this.startAutoRefresh();
    } catch (err) {
      this.onError("❌ Erreur enregistrement paiement Stripe :", err);
      this.showInfoDialog("Erreur", "Erreur lors de l'enregistrement du paiement.", true)
    }
  }

  // async sendimageToDevice(textToEncode: string, deviceId: string, userId: string) {
  //   this.pngGenerator.generateDynamicTemplate(textToEncode, '', deviceId, userId)
  // }

  showInfoDialog(title: string, message: string, isError = false): void {
    this.stopAutoRefresh();
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      // position: { bottom: '0' },
      panelClass: 'dialog-bottom-full',
      data: {title, message, isError}
    });
    dialogRef.afterClosed().subscribe(() => {
      window.location.reload();
    });
  }

  showNoteNotFoundDialog(pointOfSaleName: string, tableNumber: number): void {
    this.stopAutoRefresh();
    const dialogRef = this.noteNotFoundDialogRef = this.dialog.open(NoteNotFoundDialogComponent, {
      // position: { bottom: '0' },
      panelClass: 'dialog-bottom-full',
      data: {pointOfSaleName, tableNumber}
    });

    dialogRef.afterClosed().subscribe(() => {
      window.location.reload();
    });
  }

  openShareItemsDialog(): void {
    this.stopAutoRefresh();
    const dialogRef = this.dialog.open(ShareItemsDialogComponent, {
      // position: { bottom: '0' },
      panelClass: 'dialog-bottom-full',
      data: {
        items: this.structuredItems,
        currencyFormat: {decimalsString: this.currencyDecimals, currencySymbol: this.currencySymbol}
      }
    });

    dialogRef.afterClosed().subscribe(async (result: ShareItemsDialogResult | null) => {

      // ✅ Cas 1 : Annulation de la division
      if (result && 'action' in result && result.action === 'cancel-division' && result.item) {
        const item = result.item;
        try {
          await this.postBaseApi('cancel-split-waiting-note', {
            id_user: this.firstNote?.details[0].id_user,
            id_waiting_note: this.firstNote?.id,
            id_product: item.id,
            uuid: item.uuid?.split('-')[0] // UUID de base
          });
          this.checkForWaitingNotesUpdate();
          const message = `La division de "${item.name}" a bien été annulée.`
          this.showInfoDialog('Succès', message, false);
          this.startAutoRefresh();
        } catch (err) {
          this.onError('❌ Erreur lors de l’annulation de la division :', err);
          const message = `Impossible d’annuler la division de "${item.name}".`
          this.showInfoDialog('Erreur', message, true);
        }
        this.startAutoRefresh();
        return; // 🚨 Ne pas continuer après annulation
      }

      // ✅ Cas 2 : Nouvelle division d’articles
      const sharedParts = result as SharedPart[];

      if (sharedParts?.length) {
        // 1️⃣ Supprimer les articles originaux (non partagés) ayant été divisés
        const sharedIds = new Set(sharedParts.map(p => p.id_product));
        this.structuredItems = this.structuredItems.filter(item => {
          return !(sharedIds.has(item.id) && item.shared_index === undefined);
        });

        // 2️⃣ Ajouter les parts comme des articles virtuels
        const sharedItemsFormatted: Item[] = sharedParts.map((p) => ({
          id: p.id_product,
          name: `${p.name} - Partie ${p.shared_index}/${p.shared_total}`,
          quantity: 1,
          partialQuantity: 1,
          unit_ttc: p.amount_paid ?? 0,
          total_ttc: p.amount_paid ?? 0,
          uuid: p.uuid,
          shared_index: p.shared_index,
          shared_total: p.shared_total,
          alreadyPaid: false,
          free: 0,
          children: [],
          remainingQuantity: 1,
          selected: false,
          amount_paid: p.amount_paid,
        }));
        this.structuredItems.push(...sharedItemsFormatted);

        try {
          await this.postBaseApi('split-waiting-note', {
            id_user: this.firstNote?.details[0].id_user,
            id_waiting_note: this.firstNote?.id,
            parts: sharedParts.map((p) => ({
              id_product: p.id_product,
              uuid: p.uuid,
              shared_index: p.shared_index,
              shared_total: p.shared_total,
              name: p.name,
              amount_paid: p.amount_paid,
            }))
          });
          this.startAutoRefresh();
          this.openSelectItemsDialog();
        } catch (err) {
          this.onError('❌ Erreur lors de l’enregistrement des parts :', err);
        }
      }
      this.startAutoRefresh();
    });
  }

  openPaymentHistoryDialog(): void {
    if (!this.firstNote?.payments?.length) {
      this.showInfoDialog('Historique vide', 'Aucun paiement enregistré.', false);
      return;
    }

    this.dialog.open(PaymentHistoryDialogComponent, {
      // position: { bottom: '0' },
      panelClass: 'dialog-bottom-full',
      data: {
        payments: this.firstNote.payments,
        totalAmount: this.totalBrut,
        decimalsString: this.currencyDecimals,
        currencySymbol: this.currencySymbol
      }
    });
  }


  checkPayment(totalReceived: number, totalAmount: number): void {
    // console.log("waitingnotes.component - checkPayment - totalReceived : ", totalReceived);
    // console.log("waitingnotes.component - checkPayment - totalAmount : ", totalAmount);
    const payment = this.roundAmount(totalReceived - totalAmount);
    const details = this.firstNote?.details;
    // console.log("waitingnotes.component - checkPayment - details : ", details);

    if (payment === 0) {
      if (Array.isArray(details) && details.length !== 0) {
        this.stopAutoRefresh();
        this.dialog.open(FullyPaidDialogComponent, {
          data: {pointOfSaleName: this.pointOfSale?.name, tableNumber: this.decodedPayload['table']},
          disableClose: true, // ⛔️ Désactive la fermeture au clic à l’extérieur
          // position: { bottom: '0' },
          panelClass: 'dialog-bottom-full',
        });
      } else {
        this.stopAutoRefresh()
        this.showInfoDialog("Aucun élément sur votre table", "Revenez ici pour payer dans un moment.", false);
      }
    }
    if (payment > 0) {
      this.stopAutoRefresh();
      const dialogRef = this.dialog.open(OverPaymentDialogComponent, {
        data: {payment, currencyFormat: {decimalsString: this.currencySymbol, currencySymbol: this.currencySymbol}},
        // position: { bottom: '0' },
        panelClass: 'dialog-bottom-full',
        disableClose: true, // ⛔️ Désactive la fermeture au clic à l’extérieur
      });

      dialogRef.afterClosed().subscribe((action: 'refund' | 'tip' | 'credit' | null) => {
        if (!action) return;

        switch (action) {
          case 'refund':
            this.refundOverpayment(payment);
            break;
          case 'tip':
            this.addToTips(payment);
            break;
          case 'credit':
            this.creditOverpayment(payment);
            break;
        }
        this.startAutoRefresh();
      });
    }
    this.isLoading = false;
  }

  refundOverpayment(overpayment: number): void {
    this.showInfoDialog("Remboursement", `Nous allons rembourser ${overpayment} € au client.`);
    // TODO: implémenter la logique de remboursement.
  }

  addToTips(overpayment: number): void {
    this.showInfoDialog("Pourboire", `${overpayment} € seront ajoutés comme pourboire.`);
    // TODO: envoyer à l'API comme "tips".
  }

  creditOverpayment(overpayment: number): void {
    this.showInfoDialog("Crédit", `Les ${overpayment} € seront crédités pour une prochaine note.`);
    // TODO: stocker en tant que crédit.
  }

  calculateTotal(items: Item[]): number {
    let total = 0;

    for (const item of items) {
      if (item.total_ttc && item.free !== 1) {
        total += item.total_ttc;
      }

      if (item.children && item.children.length > 0) {
        total += this.calculateTotal(item.children);
      }
    }
    return total;
  }

  calculatePaidAmount(): number {
    if (!this.firstNote?.payments) return 0;

    const filteredPayments = this.firstNote.payments.filter(
      (payment) => payment.archive === 0 && payment.captured === 1
    );

    // console.log("waitingnotes.component - calculatePaidAmount - filteredPayments : ", filteredPayments);

    return filteredPayments.reduce((sum, payment) => {
      return sum + (payment.total || 0);
    }, 0);
  }

  // calculateTotalTips(): number {
  //   if (!this.firstNote?.payments) return 0;

  //   return this.firstNote.payments
  //     .filter(payment => payment.archive === 0)
  //     .reduce((sum, payment) => sum + (payment.TIPS || 0), 0);
  // }

  calculateTotalTips(): number {
    const payments = this.firstNote?.payments;
    if (!Array.isArray(payments)) return 0;

    return payments
      .filter(payment => payment.archive === 0)
      .map(payment => Number(payment.TIPS) || 0)
      .reduce((sum, tips) => sum + tips, 0);
  }


  markPaidItems(): void {
    const payments = this.firstNote?.payments || [];
    const paidMap = new Map<string, number>();

    // Étape 1 — Construire la paidMap
    for (const payment of payments) {
      if (payment.archive !== 0 || !payment.details) continue;

      for (const detail of payment.details) {
        const key = detail.uuid
          ? `${detail.uuid}`
          : `id-${detail.id_product}-0`;

        const qty = detail.quantity_paid ?? 0;
        paidMap.set(key, (paidMap.get(key) || 0) + qty);
      }
    }

    // Étape 2 — Récursif pour marquer les paiements dans la hiérarchie
    const markRecursively = (items: Item[]) => {
      for (const item of items) {
        const key = this.getStableKey(item);
        const paidQty = paidMap.get(key) || 0;

        item.paidQuantity = paidQty;
        item.alreadyPaid = paidMap.has(key) && paidQty >= 1;
        item.remainingQuantity = item.quantity - paidQty;

        if (item.alreadyPaid) {
          item.selected = false;
          item.partialQuantity = 0;
        }

        // 🟡 Si l’article a des enfants, on continue la récursivité
        if (item.children?.length) {
          markRecursively(item.children);
        }
      }
    };

    markRecursively(this.structuredItems);
  }

  increaseQuantity(item: Item) {
    if (item.partialQuantity < item.remainingQuantity) {
      item.partialQuantity++;
      this.updateSelectedTotal();
    }
  }

  decreaseQuantity(item: Item) {
    if (item.partialQuantity > 1) {
      item.partialQuantity--;
      this.updateSelectedTotal();
    }
  }

  updateSelectedTotal(): void {
    this.selectedTotals = this.getSelectedTotals();
  }

  getSelectedTotals(): { rawTotal: number; maxTotal: number; finalTotal: number } {
    const maxTotal = this.totalBrut - this.paidAmount;

    const computeTotal = (items: Item[]): number => {
      return items.reduce((acc, item) => {
        let subtotal = 0;

        if (item.selected && item.unit_ttc > 0 && item.free !== 1) {
          const payableQuantity = Math.min(item.partialQuantity, item.remainingQuantity ?? item.quantity ?? 1);
          subtotal += item.unit_ttc * payableQuantity;
        }

        if (item.children?.length) {
          subtotal += computeTotal(item.children);
        }

        return acc + subtotal;
      }, 0);
    };

    const rawTotal = computeTotal(this.structuredItems);
    const finalTotal = Math.min(rawTotal, maxTotal);

    return {rawTotal, maxTotal, finalTotal};
  }

  getStableKey(item: Item): string {
    if (item.uuid) {
      // Vérifie si l'uuid se termine déjà par "-<nombre>"
      const endsWithIndex = /-\d+$/.test(item.uuid);
      if (endsWithIndex) {
        return item.uuid; // Pas besoin de rajouter
      }

      // Sinon, rajoute shared_index s'il est présent
      if (item.shared_index !== undefined) {
        return `${item.uuid}-${item.shared_index}`;
      } else {
        return item.uuid;
      }
    } else {
      // Cas de fallback (sans uuid)
      return `id-${item.id}-${item.shared_index ?? '0'}`;
    }
  }

  getSelectedItems(): Item[] {
    return this.structuredItems.filter(item => item.selected && !item.alreadyPaid);
  }
}
